<div class="tag-container">
    <div *ngFor="let tag of tags" class="tag">{{ tag }}</div>
  </div>
